import React, { useState } from "react";
import { useUser } from "@dreamchimney/user-context";
import SleeveContainer from "~/Components/Containers/SleeveContainer";
import { LOCAL_STORE_JWT } from "../../utils/main";
import AddStep2 from "./AddStep2";
import { editSleeve } from "../../api/getSleeves";
import axios from "@dreamchimney/react-axios";
import { useHistory } from "react-router-dom";

const EditSleevePage = ({ match }) => {
  let history = useHistory();
  const [sleeveId, setSleeveId] = useState(match.params.id);
  const { state: userState, dispatch } = useUser();
  const [hasError, setHasError] = useState(false);

  const handleCancel = () => {
    history.push(`/sleeves/view/${sleeveId}`);
  };

  const handleSubmit = async (payload = {}) => {
    const jwt = localStorage.getItem(LOCAL_STORE_JWT) || false;
    payload = { ...payload, jwt, chimdir: userState.user.dir };
    console.log("🚀 ~ file: AddSleevePage.js ~ line 23 ~ handleSubmit ~ payload", payload);

    if (!jwt || !payload.artist || !payload.title || (payload.tags && payload.tags.length === 0)) {
      setHasError(true);
    } else {
      setHasError(false);
      // submit here
      return editSleeve(axios, sleeveId, payload);
      // console.log("result:", result);
      // history.push(`/sleeves/view/${sleeveId}`);
    }
  };

  return (
    <div className="page-edit">
      <form className="form-horizontal" name="sleeveForm" id="sleeveForm" role="form" noValidate action="javascript:;" autoComplete="off">
        <h1>Edit Sleeve</h1>

        {hasError && <div className="alert alert-danger">Something looks wrong here, please check the errors in red below.</div>}

        <SleeveContainer
          id={sleeveId}
          render={({ sleeve, next, previous }) => {
            const sleeveOwner = userState.user.dir === sleeve.chim_dir;
            console.log("🚀 ~ file: EditSleevePage.js ~ line 21 ~ EditSleevePage ~ sleeve", sleeve);
            if (!sleeveOwner) {
              return <div>This is not your sleeve please contact the owner to makes changes. Thank you.</div>;
            }
            return <AddStep2 edit sleeve={sleeve} handleSubmit={handleSubmit} handleCancel={handleCancel} />;
          }}
        />
      </form>
    </div>
  );
};

export default EditSleevePage;
